import { Dispatch, SetStateAction } from "react";

export enum FileUploadedStatus {
  OK = "OK",
  PARTIAL_ERRORS = "PARTIAL_ERRORS",
  ERRORS = "ERRORS",
  LIMIT_EXCEEDED = "LIMIT_EXCEEDED",
  EMPTY = "EMPTY",
  FORMAT_ERROR = "FORMAT_ERROR",
}

export type InputUploadFileProps = {
  selectedFileName?: string;
  fileStatus?: FileUploadedStatus | undefined;

  width?: number;
  height?: number;
  maxFileSizeMB?: number;
  showAlert?: boolean;
  selectedFile?: File;
  onFileSelected: Dispatch<SetStateAction<File>>;
  onRemove?: () => void;
};
